import { Component, OnInit, Input } from "@angular/core"
import { BaseService } from "src/app/services/base.service"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-catalog-ftth",
	templateUrl: "./catalog-ftth.component.html",
	styleUrls: ["./catalog-ftth.component.scss"]
})
export class CatalogFtthComponent implements OnInit {
	@Input() isFromModal: boolean
	@Input() buildingType: string
	services: any
	public assets_version = environment.ASSETS_VERSION

	constructor(public baseService: BaseService) {}

	ngOnInit(): void {
		this.baseService.getServicesPon().subscribe(res => {
			this.services = res
		})
	}
}
